module.exports = __webpack_public_path__ + "img/link-blue.680a04f9.svg";